import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_aspect-video _flexcol _gap-3 _jc-c _ai-c _pa-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_icon, {
      name: "ban",
      size: "2x",
      class: "_tc--accent"
    }),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "_tac" }, [
      _createElementVNode("h4", {
        role: "heading",
        "aria-level": "4",
        class: "gfu-hd gfu-hd--h4"
      }, " Your privacy settings are blocking this content "),
      _createElementVNode("div", null, " To view it, please allow third-party content in your privacy settings. ")
    ], -1 /* CACHED */)),
    _createVNode(_component_base_button, { onClick: $options.openPrivacySettings }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Manage privacy settings ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ]))
}